import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../profile/constants';

const lazy = {
    ProjectsHistoryCreate: lazyLoad(async () => {
        const { ProjectsHistoryCreate } = await import('./EditProjectsHistory');

        return { default: ProjectsHistoryCreate };
    }),
    ProjectsHistoryEdit: lazyLoad(async () => {
        const { ProjectsHistoryEdit } = await import('./EditProjectsHistory');

        return { default: ProjectsHistoryEdit };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.user-project-history.title-add',
        page: lazy.ProjectsHistoryCreate,
        path: route.patterns.individualUser.projectHistory.create,
    },
    {
        documentTitle: 'pages.user-project-history.title-edit',
        page: lazy.ProjectsHistoryEdit,
        path: route.patterns.individualUser.projectHistory.edit,
    },
];
